<!-- Tags will show only for mobile / tablets -->
<!-- <section class="tags d-block d-sm-block d-md-block d-lg-none d-xl-none">
  <div class="row">
    <base-tag
      *ngFor="let tag of product?.tags; index as i"
      [tag]="tag"
      [index]="i"
    ></base-tag>
  </div>
</section> -->

<!-- cart section -->
<div class="cart-section">
    <div class="row">
        <!-- Buy Now -->
        <!-- <div
      class="
        col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5
        p-0
        mr-20
        mb-4 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0
      "
    >
      <base-button-lg
        [disabled]="!(product?.in_stock || product?.is_allow_back_orders)"
        [loading]="cartRepositoryService.buyNowButtonLoading()"
        (buttonClicked)="buyNow(product)"
      >
        <span class="add-to-cart-btn"> Buy Now </span>
      </base-button-lg>
    </div> -->

        <!-- Add to Cart -->
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pe-0 pe-sm-0 pe-md-2 pe-lg-2 pe-xl-2 ps-0">
            @if (productInput()?.in_stock || productInput()?.is_allow_back_orders) {
            <base-button-lg [loading]="cartRepositoryService.buttonLoading()" (buttonClicked)="addToCart(productInput())">
                <span class="add-to-cart-btn">
                    @if (productInput()?.in_stock) {
                    Add to Cart
                    } @else {
                    Pre Order
                    }
                </span>
            </base-button-lg>
            } @else {
            <base-button-lg><span class="add-to-cart-btn">Coming Soon</span></base-button-lg>
            }

            <!-- Open Exchange Policy -->
            <div class="exchange-policy mt-2 mb-2">
                <!-- <span class="mr-8">free delivery</span> -->
                <span class="view-policy" (click)="openExchangePolicy()">View Shipping Details</span>
            </div>
        </div>

        @if (showProductBidding() && productInput()?.bidding?.is_bidding_active && productInput()?.in_stock) {
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 ps-0 ps-sm-0 ps-md-2 ps-lg-2 ps-xl-2 pe-0">
            <div class="bid-btn d-flex align-items-center justify-content-center" (click)="openBiddingOverlay()">
                <span>Start placing your Bid</span>
            </div>

            <div class="d-flex clickable mt-2 mb-2" (click)="openAboutBiddingOverlay()">
                <img class="bulb-icon" [src]="IMAGE_URLS.infoBulbDarkIcon" />
                <span class="bid-info-link"> What is product Bidding?</span>
            </div>
        </div>
        }

        <!-- Razorpay widgets -->
        <div id="razorpay-affordability-widget"></div>

        <!-- delivery etd status -->
        @if (productInput()?.in_stock && productInput()?.weight && showEstimatedDelivery()) {
        <div class="p-0">
            <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 p-0 mt-1 mb-2">
                <webstore-delivery-etd-status [user]="user" [productIdInput]="productInput().id || ''" [productUrlPath]="productInput().url_path || ''"></webstore-delivery-etd-status>
            </div>
        </div>
        }
        @if (!productInput().in_stock && productInput().is_allow_back_orders) {
        <p class="pre-order-caption">Contact support to know about expected delivery of your order for this product.</p>
        }
    </div>
    <!-- Global Message -->
    @if (globalMessage?.message) {
    <webstore-messages-panel [globalMessage]="globalMessage"></webstore-messages-panel>
    }
</div>